
import { defineComponent, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import { Decode, Encode } from "@/services";
import userApi from "@/api/user/";
import whApi from "@/api/warehouse/";

export default defineComponent({
  name: "kt-user-menu",
  components: {},
  setup() {
    const router = useRouter();
    const i18n = useI18n();
    const store = useStore();

    i18n.locale.value = localStorage.getItem("lang")
      ? (localStorage.getItem("lang") as string)
      : "th";

    const countries = {
      en: {
        flag: "media/flags/united-states.svg",
        name: "English",
      },
      th: {
        flag: "media/flags/thailand.svg",
        name: "English",
      },
      es: {
        flag: "media/flags/spain.svg",
        name: "Spanish",
      },
      de: {
        flag: "media/flags/germany.svg",
        name: "German",
      },
      ja: {
        flag: "media/flags/japan.svg",
        name: "Japanese",
      },
      fr: {
        flag: "media/flags/france.svg",
        name: "French",
      },
    };

    const signOut = async () => {
      localStorage.removeItem("companyId");
      localStorage.removeItem("warehouseId");
      localStorage.removeItem("branchId");
      localStorage.removeItem("user_temp");
      localStorage.clear();
      // store
      //   .dispatch(Actions.LOGOUT)
      //   .then(() => router.push({ name: "authentication-base-sign-in" }));
      await localStorage.clear();
      // router.push("/public");
      router.push("/login");
      // set หน้าแรกตรงนี้
    };

    const setLang = (lang) => {
      localStorage.setItem("lang", lang);
      i18n.locale.value = lang;
    };

    const currentLanguage = (lang) => {
      return i18n.locale.value === lang;
    };

    const currentLangugeLocale = computed(() => {
      return countries[i18n.locale.value];
    });

    return {
      signOut,
      setLang,
      currentLanguage,
      currentLangugeLocale,
      countries,
    };
  },
  data: () => ({
    user: "",
    userName: "",
    userId: "",
    classRole: "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2",
    cssSignOut: "color: #F1416C;",
    currentLang: localStorage.getItem("lang"),
    companyId: localStorage.getItem("companyId"),
    branchId: localStorage.getItem("branchId"),
    warehouseId: localStorage.getItem("warehouseId"),
    warehouseData: [],
    branchData: [],
    companyData: [],
  }),
  created() {
    this.getAllUser();
  },
  methods: {
    async getAllUser() {
      this.userId = Decode.decode(localStorage.getItem("boss"));
      let responseData = [];

      try {
        responseData = await userApi.user.getOne(this.userId);
      } catch (error) {
        console.log(error);
      }

      if (responseData["response_status"] === "SUCCESS") {
        this.user = responseData["data"];
        this.userName = responseData["data"]["firstName"];
        localStorage.setItem("userData", this.user);
        this.setClassRole();
      }
      // console.log("warehouseId", this.warehouseId);
      this.getAllWarehouse();
      this.getAllBranch();
      this.getAllCompany();
    },
    async getAllWarehouse() {
      let responseData = [];
      try {
        responseData = await whApi.warehouse.getOne(this.warehouseId);
      } catch (error) {
        console.log(error);
      }
      if (responseData["response_status"] === "SUCCESS") {
        this.warehouseData = responseData["data"];
      }
    },
    async getAllBranch() {
      let responseData = [];
      try {
        responseData = await whApi.branch.getOne(this.branchId);
      } catch (error) {
        console.log(error);
      }
      if (responseData["response_status"] === "SUCCESS") {
        this.branchData = responseData["data"];
      }
    },
    async getAllCompany() {
      let responseData = [];
      try {
        responseData = await whApi.company.getOne(this.companyId);
      } catch (error) {
        console.log(error);
      }
      if (responseData["response_status"] === "SUCCESS") {
        this.companyData = responseData["data"];
      }
    },
    setClassRole() {
      this.user["role"] === "SUPER_ADMIN"
        ? (this.classRole =
            "badge badge-light-primary fw-bolder fs-8 px-2 py-1 ms-2")
        : this.user["role"] === "ADMIN"
        ? (this.classRole =
            "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2")
        : this.user["role"] === "MANAGER"
        ? (this.classRole =
            "badge badge-light-warning fw-bolder fs-8 px-2 py-1 ms-2")
        : this.user["role"] === "BRANCH MANAGER"
        ? (this.classRole =
            "badge badge-light-danger fw-bolder fs-8 px-2 py-1 ms-2")
        : this.user["role"] === "STAFF"
        ? (this.classRole =
            "badge badge-light-info fw-bolder fs-8 px-2 py-1 ms-2")
        : (this.classRole =
            "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2");
    },

    enterSignOut() {
      this.cssSignOut = "color: #D9214E; background-color: #FFF5F8";
    },

    leaveSignOut() {
      this.cssSignOut = "color: #F1416C;";
    },
  },
});
